import React from 'react';
import MathJax from 'react-mathjax-preview';

import { KpiEntryItemForm } from './KpiEntryItemForm';
import { KpiParameterSelect } from './shared/KpiParameterSelect';
import { removeProperty } from 'utils/generic';
import kpis from 'utils/kpis';

export class KpiEntryForm extends React.PureComponent {
  handleChange = ({ target }) => {
    this.props.onUpdate({ [target.name]: target.value });
  };

  handleEquationChange = ({ target }) => {
    this.props.onEquationChange(target.value);
  };

  handleParameterChange = (parameterAssignmentId, parameter) => {
    const { kpiEntry, onUpdate } = this.props;

    onUpdate({
      parameterAssignments: {
        ...kpiEntry.parameterAssignments,
        [parameterAssignmentId]: {
          ...kpiEntry.parameterAssignments[parameterAssignmentId],
          parameter,
        },
      },
    });
  };

  handleRemoveParameterAssignment = (parameterAssignmentId) => {
    const { kpiEntry, onUpdate } = this.props;
    onUpdate({
      parameterAssignments: removeProperty(
        kpiEntry.parameterAssignments,
        parameterAssignmentId
      ),
    });
  };

  renderGroup = (g) => (
    <option key={g.id} value={g.id}>
      {g.name}
    </option>
  );

  renderEquation = () => {
    const { equation } = this.props.kpiEntry;

    if (!equation) {
      return (
        <span>
          <i>No equation typed</i>
        </span>
      );
    }

    return <MathJax math={kpis.formatToAsciiMath(equation)} />;
  };

  renderParameterAssignment = ([
    parameterAssignmentId,
    parameterAssignment,
  ]) => (
    <KpiEntryItemForm
      key={parameterAssignmentId}
      id={parameterAssignmentId}
      parameterAssignment={parameterAssignment}
      parameters={kpis.getParameters(this.props.kpiEntry.equation)}
      onChange={this.handleParameterChange}
      onRemove={this.handleRemoveParameterAssignment}
    />
  );

  renderItemsTable = () => {
    const { parameterAssignments } = this.props.kpiEntry;

    return (
      <table className="kpi-items">
        <thead>
          <tr>
            <th className="description">Account / Group</th>
            <th className="parameter">Parameter</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {Object.entries(parameterAssignments).map(
            this.renderParameterAssignment
          )}
        </tbody>
      </table>
    );
  };

  render() {
    const { kpiEntry, kpiGroups } = this.props;
    const parameters = kpis.getParameters(kpiEntry.equation);

    return (
      <form>
        <select
          name="groupId"
          value={kpiEntry.groupId}
          onChange={this.handleChange}
        >
          {kpiGroups.map(this.renderGroup)}
        </select>
        <input
          name="name"
          autoComplete="off"
          type="text"
          value={kpiEntry.name}
          onChange={this.handleChange}
          placeholder="Entry name"
        />
        <p>
          <b>Equation preview</b>
        </p>
        {this.renderEquation()}
        <p>
          <b>Equation input</b>
        </p>
        <input
          name="equation"
          autoComplete="off"
          type="text"
          value={kpiEntry.equation}
          onChange={this.handleEquationChange}
          placeholder="Entry equation"
        />
        <p>
          <b>Period days parameter</b>
        </p>
        <KpiParameterSelect
          name="periodDaysParameter"
          parameters={parameters}
          parameter={kpiEntry.periodDaysParameter}
          canSelectNone
          onChange={this.handleChange}
        />
        {this.renderItemsTable()}
      </form>
    );
  }
}
